export default __webpack_public_path__ + "static/media/manager.aa49b8e1.jpeg";